import {hasMegaPayBusinessCapabilities} from '../../../../_metronic/helpers/brand'
import {isOnPremisesInstallation} from '../../auth/core/onPremisesAccess'
import {AuthModel} from '../../auth/core/_models'
import {isStaff} from '../../auth/core/staffAccess'

// The same text is published on the company's website (ASA-Website src/app/rules/page.tsx).
export const TERMS_WEBSITE_URL = 'https://asatsp.ir/rules'

// The terms are ASA's own: the ASA and «معتمد آسا» panels show them; an on-premises installation
// (FASH on the bank's own servers) has none.
export const hasTermsOfService = (user?: Pick<AuthModel, 'isOnPremises'> | null) =>
  hasMegaPayBusinessCapabilities() && !isOnPremisesInstallation(user)

// Asked for every signed-in user, with or without a business: since version 2 (backend 1.0.0.757)
// each user accepts personally too. A support operator inside a customer's panel is not the
// customer, and staff opened from the CRM accept nothing on a business's behalf. The server decides the rest: administrators and people who are not users of the
// business are never asked to accept.
export const shouldCheckTermsAcceptance = (user?: AuthModel | null) =>
  Boolean(user && !user.support && !isStaff(user) && hasTermsOfService(user))
